<template>
    <div ref="grid">
    </div>
</template>


<script>
import canvasDatagrid from "canvas-datagrid";
import XLSX from "xlsx";
export default {
    props: {
        value: String,
        worksheet: Object,
    },
    data() {
        return {
            data: [],
            selectionBounds: null,
            grid: null,
        };
    },
    methods: {
        setData(ws) {
            try {
                let aoa = XLSX.utils.sheet_to_json(ws, { header: 1 });

                // add missing columns and rows from the start
                let range = ws["!ref"].match(/(\w+)(\d+):/);
                let missingRows = Number(range[2]) - 1;
                let missingColumns = this.fromExcelColumnName(range[1]) - 1;
                
                aoa.forEach((value) => {
                    for(let i=0; i<missingColumns; i++) { 
                        value.unshift(null);
                        delete value[0];
                    }
                })
                for(let i=0; i<missingRows; i++) aoa.unshift([]);

                // remove empty rows at the end if there are any
                for(let i=aoa.length-1; i>=0; i--) {
                    if (aoa[i].length == 0) {
                        aoa.splice(i,1);
                    } else {
                        i = -1;
                    }
                }
    
                let maxColumns = Math.max(...aoa.map(x => x.length));
                let schema = [];
                for (let index = 0; index < maxColumns; index++) {
                    schema.push({ 
                        name: index.toString(),
                        title: this.getExcelColumnName(index+1)
                    });
                }
                this.grid.data = aoa;
                this.grid.schema = schema.length? schema: [{name:"A"}];
            } catch ( error ) {
                console.error(ws, error);
            }
        },
        select(ev) {
            if (isFinite(ev.selectionBounds.left) && isFinite(ev.selectionBounds.top)) {
                let start = "" + this.getExcelColumnName(ev.selectionBounds.left + 1) + (ev.selectionBounds.top + 1);
                this.$emit("input", start);
            }
        },
        fromExcelColumnName(val) {
            var base = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ', i, j, result = 0;

            for (i = 0, j = val.length - 1; i < val.length; i += 1, j -= 1) {
                result += Math.pow(base.length, j) * (base.indexOf(val[i]) + 1);
            }

            return result;
        },
        getExcelColumnName(columnNumber) {
            if(isNaN(columnNumber)) return "";
            let dividend = columnNumber;
            let columnName = "";
            let modulo;

            while (dividend > 0) {
                modulo = (dividend - 1) % 26;
                columnName = String.fromCharCode(65 + modulo) + columnName;
                dividend = Math.floor((dividend - modulo) / 26);
            } 

            return columnName;
        },
    },
    mounted() {
        this.grid = new canvasDatagrid({
            parentNode: this.$refs.grid,
            data: [],
            editable: false,
            allowColumnReordering: false,
            allowSorting: false,
            columnHeaderClickBehavior: "none",
        });
        this.grid.addEventListener("selectionchanged", this.select);

        this.setData(this.worksheet);
    },
    watch: {
        worksheet: function(newValue, oldValue) {
            this.setData(newValue);
        },
    },
}
</script>

<style scoped>
    div {
        overflow-x: scroll;
    }
</style>

